import { gql } from '@apollo/client'
import { TERRA_PROVIDER } from '@src/graphql/fragments/terraProvider'

export const TOGGLE_PROVIDER_DATA_TYPE = gql`
  ${TERRA_PROVIDER}
  mutation toggleProviderDataType($provider: String!, $dataType: String!) {
    toggleProviderDataType(provider: $provider, dataType: $dataType) {
      providers {
        ...TerraProvider
      }
    }
  }
`
